<template>
  <div id="app">
    <HomePage />
  </div>
</template>

<!-- Global site tag (gtag.js) - Google Analytics -->
<script
  async
  src="https://www.googletagmanager.com/gtag/js?id=UA-174439506-1"
></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "UA-174439506-1");
</script>
<!-- / Global site tag (gtag.js) - Google Analytics -->

<script>
import HomePage from "@/views/HomePage.vue";

export default {
  name: "App",
  components: {
    HomePage
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #00095c;
}
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px !important;
  left: 85% !important;
  top: 20px;
  cursor: pointer !important;
}
.bm-burger-bars {
  background-color: #00095c !important;
}
.line-style {
  position: absolute;
  height: 20% !important;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: white !important;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  z-index: 100;
  background-color: #00095c !important; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
  background: rgba(0, 0, 0, 0) !important;
  z-index: 99;
}
.bm-item-list {
  color: white !important;
  margin-left: 10% !important;
  font-size: 20px !important;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.7em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}

@media (max-width: 790px) {
  .bm-burger-button {
    left: 90%;
  }
}
@media (max-width: 450px) {
  .bm-burger-button {
    left: 82%;
  }
}
</style>
